import { AnimatePresence } from 'framer-motion';
import { get, isArray, isEmpty } from 'lodash';
import { withTranslation } from 'react-i18next';

import { Error } from '@krea/common/shared-components/fields/error';
import Fieldset from '@krea/common/shared-components/fields/fieldset';
import { FileInput } from '@krea/common/shared-components/fields/file/index';
import FileItem from '@krea/common/shared-components/fields/file-item';
import FilesList from '@krea/common/shared-components/fields/files-list';
import {
  useDeleteFile,
  usePostFieldRequest,
} from '@krea/common/store/field-requests/hooks/mutations';
import { useGetOneFieldRequest } from '@krea/common/store/field-requests/hooks/queries';

import FieldRequestPreviewHeader from '../FieldRequestPreviewHeader';
import FieldRequestSaved from '../FieldRequestSaved';

const FileUploadForm = ({
  fieldRequestID,
  isPreviewMode,
  t,
  withInputLabel,
}) => {
  const { data: { field, displayName, displayText, submittedData } = {} } =
    useGetOneFieldRequest(fieldRequestID);
  const { mutate: postFieldRequest, error } =
    usePostFieldRequest(fieldRequestID);
  const { mutate: deleteFile } = useDeleteFile();

  const files = submittedData?.files || [];
  const errors = error?.data?.errors || [];

  const deleteFileFunc = (fileID) => {
    deleteFile({ fileID, fieldRequestID });
  };

  const createFormData = (files) => {
    const formData = new FormData();

    if (isArray(files) && !isEmpty(files)) {
      files.forEach((file) => {
        formData.append('files', file, file.name);
      });
    }

    return formData;
  };

  const postFiles = (files) => {
    postFieldRequest(createFormData(files));
  };

  return (
    <>
      {isPreviewMode ? (
        <FieldRequestPreviewHeader
          label={displayName}
          value={
            <>
              <AnimatePresence>
                {files.map((file) => {
                  return (
                    <FileItem
                      file={file}
                      deleteFile={deleteFileFunc}
                      isPreviewMode={isPreviewMode}
                    />
                  );
                })}
              </AnimatePresence>
            </>
          }
        />
      ) : (
        <form className="input-form" onSubmit={(e) => e.preventDefault()}>
          <Fieldset>
            <FileInput
              multiple
              id={`id-${field}`}
              label={withInputLabel && <>{displayName}</>}
              tooltip={displayText}
              files={files}
              postFiles={postFiles}
              error={get(errors, '[0].message', null)}
            />

            {files.length > 0 && (
              <FilesList label={t('iaq.uploadedFiles')}>
                <AnimatePresence>
                  {files.map((file) => {
                    return (
                      <FileItem
                        file={file}
                        deleteFile={deleteFileFunc}
                        isPreviewMode={isPreviewMode}
                      />
                    );
                  })}
                </AnimatePresence>
              </FilesList>
            )}
          </Fieldset>

          <FieldRequestSaved fieldRequestID={fieldRequestID} />

          {errors.map((error, index) => (
            <Error className="mt-3" key={index}>
              {error.message}
            </Error>
          ))}
        </form>
      )}
    </>
  );
};

export default withTranslation()(FileUploadForm);
